import { externalProductPestPacName } from '@sales-center/common'
import { selectCurrentUser } from '@user/store/authorization'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { AddServiceLocationFormModel, defaultValues } from '../formModel'
import { AddServiceLocationFormProps } from '../typings'
import { useBranches } from './useBranches'
import { useDivisions } from './useDivisions'
import { useLocationTypes } from './useLocationTypes'

export function useData(params: AddServiceLocationFormProps) {
  const { initialValues, entityBranchId, matched, matchUpdateMode } = params

  const [locationTypesLoading, locationTypes] = useLocationTypes()
  const [divisionsLoading, divisions] = useDivisions()
  const [branchesLoading, branches] = useBranches()
  const { externalProduct, externalUserId } = useSelector(selectCurrentUser)

  const isMappedUser = externalUserId !== null && externalUserId !== undefined

  const loading = locationTypesLoading || divisionsLoading || branchesLoading

  const runPestPacValidation = useMemo(() => {
    return (
      (Boolean(matched) || Boolean(matchUpdateMode)) &&
      externalProduct === externalProductPestPacName
    )
  }, [externalProduct, matched, matchUpdateMode])

  const hydratedValues = useMemo<AddServiceLocationFormModel>(() => {
    if (!loading) {
      const defaultBranch = branches.find((x) => x.value === entityBranchId)

      if (!!defaultBranch) {
        if (!!initialValues) {
          const selectedBranch = branches.find(
            (x) => x.value === initialValues.branchId,
          )

          if (!!selectedBranch) {
            return {
              ...initialValues,
              branch: selectedBranch.label,
            }
          }
          return {
            ...initialValues,
            branchId: defaultBranch.value,
            branch: defaultBranch.label,
          }
        } else {
          return {
            ...defaultValues,
            branchId: defaultBranch.value,
            branch: defaultBranch.label,
          }
        }
      }
    }

    return defaultValues
  }, [branches, entityBranchId, initialValues, loading])

  return {
    loading,
    locationTypes,
    divisions,
    branches,
    hydratedValues,
    runPestPacValidation,
    isMappedUser,
  }
}
